import { render, staticRenderFns } from "./WaterfallAward.vue?vue&type=template&id=93774094&"
import script from "./WaterfallAward.vue?vue&type=script&lang=js&"
export * from "./WaterfallAward.vue?vue&type=script&lang=js&"
import style0 from "./WaterfallAward.vue?vue&type=style&index=0&id=93774094&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports